/// <reference path="waitList.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WaitList {
    import AppointmentRequestService = Meevo.Model.AppointmentRequestService;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import ChangedDateEnum = Meevo.Components.Controls.ChangedDateEnum;
    import AppointmentBookModalService = Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService;

    declare var device;

    class WaitListController {

        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;


        static $inject = [
            "meevo.AppSettings", 
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService", 
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService", 
            "meevo.components.common.SecurityService",
            "$rootScope", 
            "$scope", 
            "$state", 
            "meevo.ContextParams", 
            'meevo.components.short-cuts.ShortCutsService', 
            "meevo.components.busy.BusyService",
            "$mdSidenav", 
            "$translate", 
            "$q", 
            "$http", 
            "$timeout", 
            "$mdDateLocale",
            "restServer", 
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.MembershipDetailsService", 
            "meevo.plugins.appointmentBook.stepOverrideService", 
            "appointmentBookHelperService",
            "appointmentBookGlobalsService", 
            "meevo.components.common.BusinessInfoDataService",
            "appointmentBookModalService",
            "meevo.plugins.note.NoteService",
            "meevo.components.interceptors.ExceptionInterceptor",
            "$filter"
        ];
        days: Array<string>;
        startDayOfWeek: number;
        defaultPresetStatus = PresetStatus.ThisWeek;
        presetList: any[];
        mockData: Array<any>;
        callSize: number;
        spinner: boolean;
        request: Meevo.Model.AppointmentRequest;
        items: any;
        notePlaceHolderText: any;
        scanData: any;
        showScan: boolean;
        priceLevelBaseEnum: number;
        isEditing: boolean;
        isSidebarOpen: boolean;
        notesToggled: boolean = false;
        numberOfDaysToScan: number;
        numberOfMonthsInAdvance: number;

        maxStartDate: Date;
        minStartDate: Date;

        isSmsEnabled :boolean;
        serviceCriteria: any;
        private shortCutGroup: IShortCutGroup;
        clientRequests: any[];
        businessHours: any[];
        businessDate: any;
        maxWaitTimeIncrements: number[] = [];

        filterCriteria: {
            dateFilter: number,
            fromDate: Date,
            toDate: Date,
            clientIds: string[],
            employee: Model.Employee,
            employeeId: string,
            employeeGenderPreference: Meevo.Model.EmployeeGenderSearchEnum
        }

        readonly todayPreset = { name: 'LABEL_TODAY', status: PresetStatus.Today }
        readonly tomorrowPreset = { name: 'LABEL_TOMORROW', status: PresetStatus.Tomorrow}
        readonly thisWeekPreset = { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek }
        readonly nextWeekPreset = { name: 'LABEL_NEXT_WEEK', status: PresetStatus.NextWeek }
        readonly customPreset = { name: 'LABEL_CUSTOM', status: PresetStatus.Custom }

        isMobile: boolean
        isFilterExpanded: boolean = false;

        employeeGenderSearchEnums: any;
        serviceAddOnPermission: boolean = false;
        enableIntegratedRegister: boolean = true;

        requestAppointmentCategory: any;
        scanTimeTypes = {};

        showPayingClientAlerts: boolean = false;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: any,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $mdSidenav: ng.material.ISidenavService,
            protected $translate: any,
            protected $q: any,
            protected $http: any,
            protected $timeout: angular.ITimeoutService,
            $mdDateLocale,
            protected restServer: any,
            protected trackingService: any,
            private membershipDetailsService,
            protected stepOverrideService,
            protected appointmentBookHelperService,
            protected appointmentBookGlobalsService,
            protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            protected $appointmentBookModal: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            protected noteService: Meevo.Plugins.Note.NoteService,
            private exceptionInterceptor: Meevo.Components.Interceptors.ExceptionInterceptor,
            private $filter: angular.IFilterService) {
            this.notePlaceHolderText = this.$translate.instant("LABEL_APPOINTMENT_REQUEST_NOTE_PLACEHOLDER");

            this.filterCriteria = {
                dateFilter: 0,
                fromDate: null,
                toDate: null, 
                clientIds: null,
                employee: null,
                employeeId: null,
                employeeGenderPreference: null
            }

            this.search();
            this.scanData = {};
            //Price levels 1-9 occupy enums 2065-2074, in the template we simply subtract 2064 from the enum to get the correct price level.
            this.priceLevelBaseEnum = 2064;

            this.$scope.$on("appointmentSaved", this.bookAppointmentSuccess);

            this.presetList = [
                this.todayPreset,
                this.tomorrowPreset,
                this.thisWeekPreset,
                this.nextWeekPreset,
                this.customPreset
            ];

            this.startDayOfWeek = $mdDateLocale.firstDayOfWeekLocale;

            restServer.LoadBusinessInfoSettings().then(result =>
                this.businessInfoLoaded(result)
            );
            restServer.LoadNotificationSettings().then(result =>
                this.notificationSettingsLoaded(result)
            );
            if (appointmentBookGlobalsService.businessInfo) {
                this.businessHours = appointmentBookGlobalsService.businessInfo.businessHours;
                this.businessDate = moment.utc().add(moment.duration(appointmentBookGlobalsService.businessInfo.timeZoneOffset));
            }
            else {
                restServer.LoadBusinessInfo().then(result => {
                    this.businessHours = result.data.businessHours;
                    this.businessDate = moment.utc().add(moment.duration(result.data.timeZoneOffset));
                });
            }
            // Set the first focus on Add to Wait List button
            setTimeout(() => {
                angular.element('.add-to-list').focus();
            }, 750);

            this.serviceCriteria = { wildCardType: Meevo.Model.FilterWildcardType.Contains, isBookable: true };

            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_SAVE_BUTTON',
                    callback: () => {
                        this.saveRequest();
                    }
                },
                {
                    shortCutName: 'MODAL_CANCEL_BUTTON',
                    callback: () => {
                        this.closeEditor();
                    }
                }
            ], {
                groupLevel: Components.ShortCuts.GroupLevels.Plugin,
                deactivateGlobal: true,
            });

            const stateName: string = this.$state.current.name;

            this.$scope.$on('$stateChangeSuccess',
                (event, toState, toParams, fromState) => {
                    if (fromState.name === stateName) {
                        this.shortCutsService.deactivateGroup(this.shortCutGroup);
                    } else if (toState.name === stateName && this.$mdSidenav('waitListEditor').isOpen()) {
                        this.shortCutsService.activateGroup(this.shortCutGroup);
                    }
                });

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                    if (state.name !== this.appSettings.ROUTE_NAMES.waitList) {
                        return;
                    }
    
                    this.applyParamsToContext(params);
                });

            this.$timeout(() => {
                if (this.contextParams.params) {
                    this.applyParamsToContext(this.contextParams.params);
                }
            });

            this.isMobile = device.mobile();
            this.isFilterExpanded = false;

            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.EmployeeGenderSearchEnum)
                .then((data: any) => this.employeeGenderSearchEnums = data);

            this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEW_ADDONS).then(result => {
                this.serviceAddOnPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });

            let maxWaitTimeIncrement = 0;
            let appointmentBookIncrementNumber = this.businessInfoDataService.getAppointmentBookIncrementInMinutes(this.$rootScope.appointmentBookSettings.appointmentBookPrecisionIncrement);
            while (maxWaitTimeIncrement < 60) {
                maxWaitTimeIncrement += appointmentBookIncrementNumber;
                this.maxWaitTimeIncrements.push(maxWaitTimeIncrement);
            }

            this.scanTimeTypes = [
                { id: Model.ScanTimeTypeEnum.Anytime, value: this.$translate.instant("LABEL_ANYTIME") },
                { id: Model.ScanTimeTypeEnum.Morning, value: this.$translate.instant("LABEL_MORNING") },
                { id: Model.ScanTimeTypeEnum.Afternoon, value: this.$translate.instant("LABEL_AFTERNOON") },
                { id: Model.ScanTimeTypeEnum.Evening, value: this.$translate.instant("LABEL_EVENING") },
                { id: Model.ScanTimeTypeEnum.Custom, value: this.$translate.instant("LABEL_BETWEEN") }
            ];
        }

        scanTypeType = Model.ScanTimeTypeEnum;
        businessInfoLoaded(result) {
            this.numberOfDaysToScan = (result.data.appointmentBookSettings.waitListNumberOfDaysToScan - 1);
            this.numberOfMonthsInAdvance = (result.data.appointmentBookSettings.waitListNumberOfMonthsInAdvance);

            this.maxStartDate = moment(this.getDate()).add(this.numberOfMonthsInAdvance, "months").toDate();
            this.minStartDate = moment(this.getDate()).toDate();

            this.enableIntegratedRegister = result.data.registerSettings.enableIntegratedRegister;
        }

        notificationSettingsLoaded(result) {
            this.isSmsEnabled = result.data.isSmsEnabled;
        }
        dateCriteriaChanged() {
            if (this.filterCriteria.dateFilter != 7) {
                this.filterCriteria.fromDate = this.filterCriteria.toDate = null;
            } else {
                this.filterCriteria.fromDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                this.filterCriteria.toDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            }

        }

        search() {            
            let request = {
                pageNumber: 0,
                itemsPerPage: 20,
                //sortBy: '',  default should be null so it can be used as the stored procs default
                sortDirection: Model.SortDirection.Ascending,
                criteria: _.omit(this.filterCriteria, 'employee')
            }
            
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.appSettings.API_ENDPOINTS.appointmentRequest, this.onPageLoad, this);
            this.items.initSearch(request);
        }

        onPageLoad(pageNumber, items, context) {
            let distinctClientIds = _(items).chain().uniq(false, (item) => {
                return item.clientId;
            }).pluck("clientId");

            //TimeSpan value corresponding to 12 AM is omitted from API responses
            _(items).each((item) => {
                if (!item.startTime) {
                    item.startTime = '00:00:00';
                }
            });

            let that = this;
            this.dataService.customMethodData("/api/Membership/Client/StatusIndicator/List", "post", { clientIds: distinctClientIds }).then(response=> {
                response.data.forEach(membership=> {
                    _(items).where({clientId: membership.clientId}).forEach(clientWaitItem=> {
                        clientWaitItem.membershipIconClass = context.membershipDetailsService.getDetails(membership, Meevo.Components.Common.MembershipDetailsPart.ClassName);
                        clientWaitItem.membershipIconPath = context.membershipDetailsService.getDetails(membership, Meevo.Components.Common.MembershipDetailsPart.IconFileName);
                        clientWaitItem.membershipIconTitle = context.membershipDetailsService.getDetails(membership, Meevo.Components.Common.MembershipDetailsPart.DisplayName);
                    })
                })
            });
        }
        
        toggleEditor = (dateTimeBand: Model.AppointmentRequestDateTimeBand, isDateRangeChanged: boolean = true) => {
            this.openEditor();
            this.shortCutsService.activateGroup(this.shortCutGroup);
            if (isDateRangeChanged) {
                this.dateRangeChanged(dateTimeBand);
            }
        }

        closeSideNav = () => {
            $("#dateChangeNote").html("");
            $(".wait-list-editor-column").scrollTop(0);
            this.isSidebarOpen = false;
            this.isEditing = false;
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
            this.request = undefined;
            this.hidePayingClientAlerts();
        }

        closeEditor = () => {
            this.requestAppointmentCategory = null;
            this.$mdSidenav('waitListEditor').close();
        }

        closeContext(): void {
            this.$rootScope.$broadcast("closeContext", this.$state.current, null);
        }

        getMinDate = (date) => {
            return moment(date).format("YYYY-MM-DDT04:00:00");
        }

        scanTimeTypeChange(dateTimeBand: Model.AppointmentRequestDateTimeBand) {
            dateTimeBand.startTimeTemp = undefined;
            dateTimeBand.endTimeTemp = undefined;

            if (!this.businessHours || dateTimeBand.scanTimeType != Model.ScanTimeTypeEnum.Custom)
                return;

            let startTempDateTime = moment("09:00", "HH:mm").toDate();
            let endTempDateTime = moment("21:00", "HH:mm").toDate();

            let businessDateTime = this.appointmentBookHelperService.getBusinessHoursForDate(this.businessDate, this.businessHours);
            if (businessDateTime && businessDateTime.isEnabled) {
                let appointmentBookIncrementNumber = this.businessInfoDataService.getAppointmentBookIncrementInMinutes(this.$rootScope.appointmentBookSettings.appointmentBookPrecisionIncrement);

                let tempHours = businessDateTime.startTime.getHours();
                if (tempHours < 1) {
                    startTempDateTime = moment("00:00", "HH:mm").toDate();
                }
                else {
                    startTempDateTime = moment(`${tempHours}:00`, "HH:mm").toDate();
                }

                tempHours = businessDateTime.endTime.getHours();
                let tempMinutes = businessDateTime.endTime.getMinutes();
                if (tempHours >= 23) {
                    endTempDateTime = moment(`23):${(tempMinutes > 0 ? (60 - appointmentBookIncrementNumber) : 0)}`, "HH:mm").toDate();
                }
                else {
                    tempHours = tempHours + (tempMinutes > 0 ? 1 : 0);
                    endTempDateTime = moment(`${tempHours}:00`, "HH:mm").toDate();
                }
            }

            dateTimeBand.startTimeTemp = { value: startTempDateTime };
            dateTimeBand.endTimeTemp = { value: endTempDateTime };
        }

        addDateTimeBand() {
            this.request.dateTimeBands = this.request.dateTimeBands || [];
            let dateTimeBand = {
                startDate: this.getDate(moment().toDate()),
                endDate: this.getDate(moment().day("Sunday").add(6, "days").toDate()),
                daysOfWeek: [],
                scanTimeType: Model.ScanTimeTypeEnum.Anytime,
                sequenceId: -1,
                selectedPreset: this.getPreset(PresetStatus.ThisWeek)
            };
            this.setThisWeekDefault(dateTimeBand);
            this.request.dateTimeBands.push(dateTimeBand);
            this.dateRangeChanged(dateTimeBand);
        }

        removeDateTimeBand(index: number) {
            this.request.dateTimeBands.splice(index, 1);
        }

        private setThisWeekDefault(dateTimeBand: Model.AppointmentRequestDateTimeBand) {
            dateTimeBand.startDate = moment().startOf('day').toDate();

            let endDate = moment();
            let locale = { ...endDate['_locale'] };
            locale['_week'] = { ...locale['_week'] };
            locale['_week']['dow'] = this.startDayOfWeek;
            endDate['_locale'] = locale;

            dateTimeBand.endDate = endDate.day(this.startDayOfWeek).add(6, 'days').startOf('day').toDate();
        }

        addRequest = () => {
            this.clientId = null;
            this.isEditing = false;
            this.isSidebarOpen = true;

            this.request = {
                services: [],
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT
            };
            this.addDateTimeBand();
            this.addRequestService(this.request);
            this.openEditor();
            this.shortCutsService.activateGroup(this.shortCutGroup);
            this.dataService.trackUsage(Model.NounEnum.WaitListPage, Model.VerbEnum.Created, null);
        }

        openEditor() {
            const sideNav = this.$mdSidenav('waitListEditor');
            sideNav.onClose(() => this.closeSideNav());
            sideNav.open();
        }

        editRequest(request)
        {
            this.clientId = null;
            const requestId = request.id;
            this.hidePayingClientAlerts();

            const edit = () => {
                this.clientRequests = null;
                this.isEditing = true;

                this.shortCutsService.activateGroup(this.shortCutGroup);

                this.getRequest(requestId, false).then((data : Model.AppointmentRequest) => {
                    this.request = data;
                    this.requestAppointmentCategory = {
                        id: data.appointmentCategoryId,
                        displayName: data.appointmentCategoryDisplayName
                    };
                    for (let service of this.request.services) {
                        this.setEmployeeCriteria(service);
                        this.hasServicingClientAlerts(service);
                    }

                    for (let dateTimeBand of this.request.dateTimeBands) {
                        dateTimeBand.selectedPreset = this.getPreset(PresetStatus.Custom);
                    }

                    if (this.request.payingClient) {
                        this.hasPayingClientAlerts();
                    }

                    this.openEditor();
                });
                this.dataService.trackUsage(Model.NounEnum.WaitListPage, Model.VerbEnum.Updated, null, requestId);
            }

            if (request.isOnlineBookingRequest) {
                const options: Components.Modal.ILocalOptions = {
                    okButtonContentKey: 'LABEL_YES',
                    showCancelButton: true,
                    cancelButtonContentKey: 'LABEL_NO',
                    modalClass: 'modal-alert'
                }
                this.modalService.confirm('MESSAGE_WAIT_LIST_EDIT_ONLINE_BOOKING_REQUEST', 
                    Components.Modal.ModalTranslationModes.Translate, 
                    false,
                    options).then(res => {
                        if (res) {
                            edit();
                        }
                    });
                return;
            }

            edit();
        }

        getRequest(requestId, addEmptyRequestService: boolean = true): any {
            let deferred = this.$q.defer();
            this.dataService.customMethodData(`api/${this.appSettings.API_ENDPOINTS.appointmentRequest}/${requestId}`, "get", null,
                { verifyHasServiceAddOn: true }).then((response) => {
                let data: Model.AppointmentRequest = response.data;
                // if request is expired, treat it like a new request
                if (_(data.dateTimeBands).all(dateTimeBand => moment(dateTimeBand.endDate).startOf('day') < moment().startOf('day'))) {
                    data.id = undefined;
                }
                for (let dateTimeBand of data.dateTimeBands) {
                    dateTimeBand.startTimeTemp = { value: moment(dateTimeBand.startTime, "HH:mm").toDate() };
                    dateTimeBand.endTimeTemp = { value: moment(dateTimeBand.endTime, "HH:mm").toDate() };
                }
                
                data.services.forEach((waitService) => {
                    this.stepOverrideService.calculateStepDuration(waitService);
                    waitService.priceLevel = waitService.priceLevel || "";
                });
                if (addEmptyRequestService) {
                    this.addRequestService(data);
                }
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        deleteRequest(requestId, entityVersion) {

            this.modalService.warning("MESSAGE_DELETE_CONFIRMATION", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response) => {
                        this.modalService.confirm("MESSAGE_MISSED_OPPORTUNITY")
                            .then((response) => {
                                this.doDelete(requestId, entityVersion, true);
                            })
                            .catch((reason) => {
                                this.doDelete(requestId, entityVersion, false);
                            });
                    }
                    );
        }

        moveToTopRequest = (item: any, priority: Number) => {
            this.modalService.confirm("MESSAGE_CONFIRM_MOVE_TO_TOP").then((response) => {
                //if yes move
                this.updateRequestPriority(item.id, priority, item);
            }).catch((reason) => {
                //no do nothing
                return;
            });
        }

        incrementRequestPriority = (item: any, priorityIncrement: Number) => {
            this.updateRequestPriority(item.id, item.priority + priorityIncrement, item);
        }

        isExpired(endDate) {
            return (new Date(moment(endDate).format("L")) < new Date(moment(new Date()).format("L")));//return (new Date(endDate) < new Date());
        }
        scan(requestId) {
            let uri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.appointmentRequest}/${requestId}/opening/List`;

            return this.$http.get(uri, {});
        }
        private doDelete(requestId, entityVersion, isMissedOpportunity) {
            let uri = `/${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.appointmentRequest}/${requestId}`;

            return this.$http.delete(uri, {
                params: {
                    entityVersion: entityVersion,
                    isMissedOpportunity: isMissedOpportunity
                }
            }).then((response) => this.search());
        }

        removeRequestService = (index) => {
            this.request.services.splice(index, 1);
        }

        removeEmployee = (service : AppointmentRequestService, index: number) : void => {
            service.employees.splice(index, 1);
            this.setEmployeeCriteria(service);
            this.rebuildSteps([service], index);
        }

        addRequestService(request: Model.AppointmentRequest) {
            request.services.push({
                employees: [],
                priceLevel: "",
                genderPreference: Model.EmployeeGenderSearchEnum.AnyEmployee,
                employeeCriteria: { showEmployeesOnly: true }
            });
            this.setEmployeeCriteria(request.services[0]);
        }

        getUniqueClientCount(hasService = false) {
            if (!this.request) {
                return 0;
            }

            return _(this.request.services).chain().
                filter((requestService) => requestService.client != null && (hasService ? requestService.service != null : true)).
                pluck("client").pluck("id").uniq().value().length;
        }

        getValidRowCount() {
            if (!this.request) {
                return 0;
            }

            return _(this.request.services).filter(requestService => requestService.client != null &&
                requestService.service != null).length;
        }

        requireSameResourceChanged() {
            if (this.request.requireSameResource) {
                this.request.requireSameStartTime = true;
            }
        }
        toTime(timeString) {
            if (timeString) {
                var timeTokens = timeString.split(':');
                return new Date(1970, 0, 1, timeTokens[0], timeTokens[1], timeTokens[2]);
            }
        }

        getTimeLabel(dateTimeBand: Model.AppointmentRequestDateTimeBand): string {
            switch (dateTimeBand.scanTimeType)
            {
                case Model.ScanTimeTypeEnum.Morning:
                    return this.$translate.instant("LABEL_MORNING");
                case Model.ScanTimeTypeEnum.Afternoon:
                    return this.$translate.instant("LABEL_AFTERNOON");
                case Model.ScanTimeTypeEnum.Evening:
                    return this.$translate.instant("LABEL_EVENING");
                case Model.ScanTimeTypeEnum.Anytime:
                    return this.$translate.instant("LABEL_ANYTIME");
                default:
                    let filter:any = this.$filter("meevoTimeFilter");
                    return `${filter(this.toTime(dateTimeBand.startTime))} ${this.$translate.instant("LABEL_TO_")} ${filter(this.toTime(dateTimeBand.endTime))}`
            }
        }

        saveRequest() {
            for (let dateTimeBand of _(this.request.dateTimeBands).where({ scanTimeType: Model.ScanTimeTypeEnum.Custom })) {
                dateTimeBand.startTime = moment(dateTimeBand.startTimeTemp.value).format("HH:mm:ss.SSSSSSS");
                dateTimeBand.endTime = moment(dateTimeBand.endTimeTemp.value).format("HH:mm:ss.SSSSSSS");
            }
            this.request.payingClientId = this.request.payingClient ? this.request.payingClient.id : undefined;
            if (this.validate()) {
                this.request.isOnlineBookingRequest = false;
                this.doSave();
            }
        }

        private doSave = () =>
        {
            this.determineStepRemoval().then((requestToSave) => {
                requestToSave.services = this.validServices(requestToSave);

                if (!this.request.id) {
                    this.dataService.add(this.appSettings.API_ENDPOINTS.appointmentRequest, requestToSave).then((data) => {
                        this.processResponse(data);
                    }, (error) => this.processError(error));
                } else {
                    this.dataService.update(`${this.appSettings.API_ENDPOINTS.appointmentRequest}/${this.request.id}`, requestToSave).then((data) => {
                        this.processResponse(data);
                    }, (error) => this.processError(error));
                }
            });
        }

        private determineStepRemoval(): ng.IPromise<Model.AppointmentRequest>
        {
            let deferred = this.$q.defer();
            let clone: Model.AppointmentRequest = jQuery.extend(true, {}, this.request);
            let promises = [];
            clone.services.forEach(service =>
            {
                let promise = this.loadEmployeeServiceOverrides(service, service.clientId).then((overrides) => {
                    if (_(service.steps).all(step => {
                        return step.durationInMinutes === step.defaultDurationInMinutes;
                    }) ||
                        (angular.isDefined(service.stepOverrideStage) && 
                            (service.stepOverrideStage === Meevo.Model.StepOverrideStageEnum.Add ||
                                service.stepOverrideStage === Meevo.Model.StepOverrideStageEnum.Update))
                        ||
                        //checking if Client has intellibooking set for this service, steps opened but weren't not changed, then we can remove steps from wait
                        (service.stepOverrideStage === Meevo.Model.StepOverrideStageEnum.Existing &&
                            angular.isDefined(overrides) && overrides.length > 0 && this.isAllIntelliBookingStepsMatchCurrentService(overrides[0], service))
                    ) {
                        service.steps = [];
                    }
                });
                promises.push(promise);
            });
            this.$q.all(promises).then(() => {
                deferred.resolve(clone);
            });
            return deferred.promise;
        }

        private isAllIntelliBookingStepsMatchCurrentService(intelliBookingService, service) {
            let retValue = true;
            _(service.steps).each((service) => {
                let intelliBookingServiceStep = _(intelliBookingService.steps).where({ stepId: service.serviceStepId })
                if (intelliBookingServiceStep != undefined && intelliBookingServiceStep.length > 0 &&
                    service.durationInMinutes != intelliBookingServiceStep[0].minutes) {
                    retValue = false;
                }
            });
            return retValue;
        }

        private loadEmployeeServiceOverrides = (service: any, clientId: any): ng.IPromise<any> => {

            if (!service.isEnableIntelliBooking) {
                return this.$q.resolve();
            }

            let uri = `/api/Client/ServiceStepOverrides`;
            let request: Model.ClientEmployeeServiceStepOverrides = {
                clientId: clientId,
                ServiceGlobalId: service.serviceId
            }

            return this.dataService.customMethodData(uri, 'Post', request).then((res: any) => {
                let overrides = res.data;
                overrides.forEach((srv: Model.ClientServiceStepOverrides) => {
                    srv.steps.forEach((step: Model.ServiceStepOverride) =>
                        step.stepTypeDisplay = step.stepTypeDisplay || Model.ServiceStepTypeEnum[step.stepType])

                    if (!srv.employeeGlobalId) {
                        srv.employeeGlobalId = null;
                        srv.displayName = this.$translate.instant('LABEL_ANY_EMPLOYEE');
                    }
                });
                return overrides;
            });
        }


        private processResponse = (data) => {
            if (data.isWarning) {
                this.handleWarnings(data.responseStatus.errors);
            } else {
                this.request.services.forEach(service => {
                    this.stepOverrideService.save(service, service.client, data.id, Model.NounEnum.WaitList);
                });
                this.closeEditor();
                this.search();
            }
        }

        private processError(error) {
            if (error.statusText === this.exceptionInterceptor.duplicateAppointmentRequestValidationExceptionKey) {
                let message = "";
                for (let clientName of error.data.responseStatus.errors[0].customState) {
                    message += `${this.$translate.instant("MESSAGE_SERVICE_EXISTING_APPOINTMENT_REQUEST_SERVER", { clientDisplayName: clientName })}<br/>`;
                }
                this.modalService.alert(message);
            }
            for (let dateTimeBand of this.request.dateTimeBands) {
                var diffOfDays = moment(moment(dateTimeBand.endDate).startOf("day")).diff(moment(moment(dateTimeBand.startDate).startOf("day")), "days");
                if (diffOfDays > this.numberOfDaysToScan || diffOfDays < 0) {
                    dateTimeBand.startDate = moment(dateTimeBand.endDate).add(-this.numberOfDaysToScan, "days").toDate();
                }
            }
        }

        handleWarningsConfirm(warnings: any[]): ng.IPromise<boolean> {

            let message: string = "";

            if (_(warnings).any((warning) =>
            {
                return +warning.errorCode === Model.MeevoApiResponseCodeEnum.AppointmentRequestExistingAppointmentService;
            })) {
                let warningsJson = warnings.map((warning) => JSON.parse(warning.message));
                let warningsGroupedByClient = _(warningsJson).groupBy("clientId");
                for (let clientId of Object.keys(warningsGroupedByClient)) {
                    message += `${this.$translate.instant("MESSAGE_EXISTING_APPOINTMENT_REQUEST_WARNING_HEADER", { clientDisplayName: warningsGroupedByClient[clientId][0].clientDisplayName } )}<br/><ul>`;
                    for (let warning of warningsGroupedByClient[clientId]) {
                        message += `<li>${warning.appointmentServiceDate}:${warning.serviceDisplayName}</li>`;
                    }
                    message += `</ul>`;
                }
               
                message += this.$translate.instant("MESSAGE_EXISTING_APPOINTMENT_REQUEST_WARNING_FOOTER");
            } else {
                for (let warning of warnings) {
                    message += `${warning.message}\n`;
                }
            }
            
            return this.modalService.confirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        private handleWarnings(warnings: any[]): ng.IPromise<any> {
            return this.handleWarningsConfirm(warnings).then((response: boolean) => {
                if (response) {
                    this.request.suppressWarnings = true;
                    return this.doSave();
                }
                return response;
            });
        }

        private validate() {
            if (!_(this.validServices(this.request)).any()) {
                return false;
            }


            if (_(this.request.dateTimeBands).any(dateTimeBand => moment(dateTimeBand.endDate).startOf("day") <
                moment(dateTimeBand.startDate).startOf("day"))) {
                this.modalService.alert("ERROR_APPOINTMENT_REQUEST_END_DATE_BEFORE_START_DATE", ModalTranslationModes.Translate);
                return false;
            }

            if (_(this.request.dateTimeBands).any(dateTimeBand => dateTimeBand.endTime <= dateTimeBand.startTime)) {
                this.modalService.alert("MESSAGE_END_TIME_GREATER_START_TIME", ModalTranslationModes.Translate);
                return false;
            }

            if (_(this.request.dateTimeBands).any(dateTimeBand => dateTimeBand.daysOfWeek.length < 1)) {
                return false;
            }

            return true;
        }

        private validServices(request : Model.AppointmentRequest): Model.AppointmentRequestService[] {
            return _(request.services).filter(service => service.client && service.service &&
                (service.genderPreference !== Model.EmployeeGenderSearchEnum.SpecificEmployee || service.employees.length > 0));
        }

        employeeCatChanged(requestService: AppointmentRequestService) {
            requestService.employeeCatId = requestService.employeeCat ? requestService.employeeCat.id : undefined;
        }

        serviceChanged(requestService: AppointmentRequestService, index: number) {
            requestService.serviceId = requestService.service ? requestService.service.id : undefined;
            this.setEmployeeCriteria(requestService);
            requestService.hasServiceAddOn = undefined;
            requestService.serviceAddOns = [];
            this.loadClientRequests(requestService.client).then(() =>
            {
                if (_(this.clientRequests).any((request: any) => request.id !== this.request.id && !request.isExpired &&
                    request.services.find(service =>
                        requestService.service.id === service.serviceId))) {
                    this.modalService.alert("MESSAGE_SERVICE_EXISTING_APPOINTMENT_REQUEST_CLIENT").then(() => requestService.service = null);
                } else {
                    this.rebuildSteps([requestService], index, true);
                    this.commonRowChanged(requestService, index)
                    this.handleServiceNotes(requestService.service);
                }
            });
        }

        private getEmployeeIdForAppointmentRequestService(appointmentRequestService: Model.AppointmentRequestService): string {
            if (appointmentRequestService.employees && appointmentRequestService.employees.length === 1) {
                return appointmentRequestService.employees[0].id;
            }
            return null;
        }

        private rebuildSteps(requestServices, index: number, serviceChanged = false) {
            let validServices: any = _(requestServices).filter((service => {
                return service.service && angular.isDefined(service.client);
            }));
            if (validServices.length === 0) {
                return this.$q.resolve();
            }

            if (validServices.length === 1) {
                return this.restServer.getAppointmentServiceTemplateWithAddOns(
                    this.getEmployeeIdForAppointmentRequestService(validServices[0]),
                    validServices[0].service.id,
                    validServices[0].client.id,
                    _(validServices[0].serviceAddOns).pluck("addOnServiceId"),
                    undefined,
                    (response) => {
                        validServices[0].serviceAlerts = [];
                        validServices[0].service.doNotAllowStepTimingOverride = response.doNotAllowStepTimingOverride;
                        validServices[0].isEnableIntelliBooking = response.isEnableIntelliBooking;
                        if (!angular.isDefined(validServices[0].hasServiceAddOn) && this.serviceAddOnPermission && response.hasServiceAddOn) {
                            //Timeout for the time it takes the typeahead dropdown to close and the mobile keyboard to disappear
                            this.$timeout(() => {
                                this.showServiceAddOns(validServices[0], index, true);
                            }, 500);
                        }
                        validServices[0].hasServiceAddOn = response.hasServiceAddOn;
                        this.updateSteps(validServices[0], response.steps);
                    });
            } else {
                return this.dataService.customMethodData(`/api/appointmentservice/templatelist`, "post",
                    {
                        employeeServiceClientIds: _(validServices).map(service => {
                            return {
                                serviceId: service.service.id,
                                employeeId: this.getEmployeeIdForAppointmentRequestService(service),
                                clientId: service.client.id
                            }
                        })
                    }
                )
                    .then(response => {

                        validServices.forEach(requestService => {
                            let employeeId = this.getEmployeeIdForAppointmentRequestService(requestService);
                            let template = requestService.steps = _(response.data).findWhere({
                                employeeId: employeeId || emptyGuid(),
                                serviceId: requestService.service.id
                            });
                            if (serviceChanged && !template.employeePerformsService && employeeId) {
                                requestService.employees = [];
                            }
                            requestService.isEnableIntelliBooking = template.isEnableIntelliBooking;
                            requestService.service.doNotAllowStepTimingOverride = template.doNotAllowStepTimingOverride;
                            this.updateSteps(requestService, template.steps)
                        });
                    });
            }
        }

        updateSteps(requestService, steps) {
            requestService.steps = _(steps).map(step => {
                return {
                    serviceStepId: step.serviceStepId,
                    durationInMinutes: step.durationInMinutes,
                    defaultDurationInMinutes: step.defaultDurationInMinutes,
                    serviceStepType: step.serviceStepType,
                    serviceStepDisplayName: step.serviceStepDisplayName,
                    serviceStepTypeDisplayName: step.serviceStepTypeDisplayName
                }
            });
            this.stepOverrideService.initializeStage(requestService);
        }

        employeeRequired(requestService: AppointmentRequestService) {
            return requestService.genderPreference === Model.EmployeeGenderSearchEnum.SpecificEmployee &&
                !requestService.employees.length;
        }

        employeeChanged(requestService: AppointmentRequestService, index: number)
        {
            requestService.stepOverrideStage = Meevo.Model.StepOverrideStageEnum.None;
            if (requestService.employee) {
                requestService.employees.push(requestService.employee);
                this.setEmployeeCriteria(requestService);

                this.rebuildSteps([requestService], index);
                requestService.employee = null;
            }
        }

        setEmployeeCriteria(requestService: AppointmentRequestService) {
            requestService.employeeCriteria = {
                showEmployeesOnly: true,
                serviceIdList: requestService.serviceId ? [requestService.serviceId] : [],
                excludeIdList: _(requestService.employees).pluck("id")
            };
        }

        private handleClientNotes(client) {
            if (!client) {
                return this.$q.resolve(true);
            }
            const noteClient: Meevo.Plugins.Note.INoteClient = {
                entityId: client.id,
                clientId: client.id,
                clientType: Meevo.Model.ClientTypeEnum.Client,
                clientDisplayName: client.displayName
            }

            return this.getAggregatedNotes(noteClient, null)
                .then(aggregatedNotes => {
                    return this.noteService.showNotes(aggregatedNotes);
                });
        }
        private handleServiceNotes(service) {
            if (!service) {
                return this.$q.resolve(true);
            }
            const noteService: Meevo.Plugins.Note.INoteService = {
                entityId: service.id,
                serviceId: service.id,
            };

            return this.getAggregatedNotes(null, [noteService])
                .then(aggregatedNotes => {
                    return this.noteService.showNotes(aggregatedNotes);
                });
        }
        private getAggregatedNotes(
            noteClient: Meevo.Plugins.Note.INoteClient,
            noteServices: Meevo.Plugins.Note.INoteService[]
                ): ng.IPromise<Meevo.Plugins.Note.INote[]> {
            if (!noteClient && !noteServices) {
                return this.$q.resolve([]);
            }
            const noteViewTime = Meevo.Model.ClientNoteViewTimeEnum.AppointmentBooked;
            const noteClients = noteClient ? [noteClient] : undefined;

            return this.noteService.loadAggregatedNotes(null, noteClients, noteServices, noteViewTime).then((response) => {
                const clientNotes = this.noteService.parseAggregatedNotes(response.data, noteClient);
                const serviceNotes = [];
                if (noteServices) {
                    for (const noteService of noteServices) {
                        const formattedNotes = this.noteService.parseAggregatedNotes(response.data, noteService);
                        serviceNotes.push(...formattedNotes);
                    }
                }
                const aggregatedNotes = [...clientNotes, ...serviceNotes];
                return aggregatedNotes;
            });
        }

        dateRangeChanged(dateTimeBand: Model.AppointmentRequestDateTimeBand) {
            var noOfDays = moment(moment(dateTimeBand.endDate).startOf("day")).diff(moment(moment(dateTimeBand.startDate).startOf("day")), "days");
            if (noOfDays > this.numberOfDaysToScan) {
                noOfDays = this.numberOfDaysToScan;
            }
            dateTimeBand.daysOfWeek = this.selectDaysOfWeek(dateTimeBand, moment(dateTimeBand.startDate).day(), noOfDays);
        }

        dateRangePresetChanged(dateTimeBand: Model.AppointmentRequestDateTimeBand, changedDate: ChangedDateEnum, changedValue) {

            if (changedDate !== ChangedDateEnum.Both) {
                return;
            }

            if (changedValue == this.thisWeekPreset) {
                this.setThisWeekDefault(dateTimeBand);
            }

            this.dateRangeChanged(dateTimeBand);
            $("#dateChangeNote").html("");
        }

        customDateChanged(dateTimeBand: Model.AppointmentRequestDateTimeBand, changeDate: ChangedDateEnum) {
            var diffOfDays = moment(moment(dateTimeBand.endDate).startOf("day"))
                .diff(moment(moment(dateTimeBand.startDate).startOf("day")), "days");

            if (changeDate === ChangedDateEnum.From) {
                this.startDateChanged(dateTimeBand, diffOfDays);
            } else {
                this.endDateChanged(dateTimeBand, diffOfDays);
            }

            this.dateRangeChanged(dateTimeBand);
        }

        startDateChanged(dateTimeBand: Model.AppointmentRequestDateTimeBand, diffOfDays) {
            $("#dateChangeNote").html("");
            if (diffOfDays > this.numberOfDaysToScan || diffOfDays < 0) {
                dateTimeBand.endDate = moment(dateTimeBand.startDate).add(this.numberOfDaysToScan, "days").endOf('day').toDate();
                this.checkForDateChangeNote(true);
            }
        }

        endDateChanged(dateTimeBand: Model.AppointmentRequestDateTimeBand, diffOfDays) {
            $("#dateChangeNote").html("");
            if (diffOfDays > this.numberOfDaysToScan || diffOfDays < 0) {
                dateTimeBand.startDate = moment(dateTimeBand.endDate).add(-this.numberOfDaysToScan, "days").startOf('day').toDate();
                this.checkForDateChangeNote(false);
            }
        }

        checkForDateChangeNote(isStartDateChanged = false) {
            if (isStartDateChanged) {
                $("#dateChangeNote").html(this.$translate.instant("LABEL_START_DATE_ADJUST_NOTE", {
                    numberOfDays: (this.numberOfDaysToScan + 1)
                }));
            } else {
                $("#dateChangeNote").html(this.$translate.instant("LABEL_END_DATE_ADJUST_NOTE", {
                    numberOfDays: (this.numberOfDaysToScan + 1)
                }));
            }
        }

        private checkClientRestrictedWarning(client) {
            if (client.isRestricted) {

                let locals = { message: this.$translate.instant("MESSAGE_CLIENT_RESTRICTED"), config: { messageClass: "high" } };
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/AppointmentBook/views/Message.html",
                    controller: "meevo.plugins.appointmentBook.MessageController",
                    controllerAs: "vm",
                    bindToController: true,
                    multiple: true,
                    skipHide: true,
                    onComplete: undefined,
                    locals: locals
                }
                return this.modalService.showCustom(options);
            }
            else {
                return this.$q.resolve();
            }
        }

        showNotesModal() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/waitList/views/waitListNoteModal.html",
                controller: "meevo.plugins.waitList.WaitListNoteModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    originalNote: this.request.note || '',
                    placeholder: this.notePlaceHolderText
                }
            };
            this.modalService.showCustom(options).then((res) => {
                this.request.note = res;
            })
        }

        payingClientChanged() {
            if (!this.request.payingClient) {
                this.hidePayingClientAlerts();
                return;
            }

            this.hasPayingClientAlerts();

            let servicingClientChanged = false;
            let servicingClientChangedPromise;
            if (this.request.payingClientId && this.request.payingClient.id !== this.request.payingClientId &&
                _(this.request.services).any((service) => {
                    return service.clientId != this.request.payingClient.id;
                })){
                servicingClientChangedPromise = this.modalService.confirmHandler("LABEL_WAIT_PAYING_CLIENT_CHANGED").then((resp: boolean) => {
                    if (resp) {
                        servicingClientChanged = true;
                        for (let service of this.request.services) {
                            service.client = this.request.payingClient;
                            service.clientId = service.client.id;
                            this.hasServicingClientAlerts(service);
                        }
                        return this.checkRequestsForClient(this.request.services, 0);
                    }
                })
            }
            else if (this.request.services.length === 1 && !this.request.services[0].client) {
                this.request.services[0].client = this.request.payingClient;
                this.request.services[0].clientId = this.request.payingClient.id;
                servicingClientChanged = true;
                servicingClientChangedPromise = this.checkRequestsForClient([this.request.services[0]], 0);
                this.hasServicingClientAlerts(this.request.services[0]);
            }
            else {
                servicingClientChangedPromise = this.$q.resolve();
            }

            servicingClientChangedPromise.then(() => {
                return this.checkClientRestrictedWarning(servicingClientChanged ? this.request.services[0].client : this.request.payingClient);
            }).then(() => {
                let notesPromise = servicingClientChanged ? this.handleClientNotes(this.request.services[0].client) :
                    this.$q.resolve();
                notesPromise.then(() => {
                    this.notifyViaTextChanged();
                });
            });
            this.request.payingClientId = this.request.payingClient.id;   
        }

        checkRequestsForClient(services: Model.AppointmentRequestService[], index: number) {
            this.clientRequests = null;
            return this.loadClientRequests(services[0].client).then(() => {
                let requests = this.clientRequests.filter(request => request.id !== this.request.id);
                let existingServiceIds = _(requests).chain().filter(request => !request.isExpired).pluck("services").flatten().pluck("serviceId").value();
                let duplicateServices = _(services).filter((service) => _(existingServiceIds).indexOf(service.serviceId) !== -1);
                if (_(duplicateServices).any()) {
                    for (let duplicateService of duplicateServices) {
                        duplicateService.client = null;
                        this.hideServicingClientAlerts(duplicateService);
                    }

                    return this.modalService.alert("MESSAGE_CLIENT_EXISTING_APPOINTMENT_REQUEST_WITH_SERVICE").then(() => {
                        let remainingServices = _(services).without(...duplicateServices);
                        if (_(remainingServices).any()) {
                            return this.rebuildSteps(services, index);
                        }
                    });
                }
                else if (requests.filter(request => !request.isExpired).length > 1) {
                    return this.modalService.alert("MESSAGE_CLIENT_MULTIPLE_APPOINTMENT_REQUESTS");
                }
                else if (requests.length > 0) { // Could be combination of up to one non-expired and zero or more expired
                    let request = requests.find(request => !request.isExpired);
                    if (request) {
                        return this.showClientChangedPrompt(WaitListClientChangedPromptEditOptionEnum.EditActive, request, services[0].client);
                    } else {
                        return this.showClientChangedPrompt(WaitListClientChangedPromptEditOptionEnum.EditExpired, requests[0], services[0].client);
                    }
                }
                else {
                    return this.rebuildSteps(services, index);
                }
            });
        }
        servicingClientChanged(requestService: Model.AppointmentRequestService, index: number) {
            requestService.clientId = undefined;
            if (!requestService.client) {
                this.hideServicingClientAlerts(requestService);
                return;
            }
            
            this.hasServicingClientAlerts(requestService);

            requestService.clientId = requestService.client.id;

            let payingClientChanged = false;
            if (!this.request.payingClient) {
                this.request.payingClient = requestService.client;
                this.request.payingClientId = requestService.client.id;
                payingClientChanged = true;
            }
            
            this.checkClientRestrictedWarning(requestService.client).then(() => {
                return this.checkRequestsForClient([requestService], index);
            }).then(() => {
                return this.handleClientNotes(requestService.client);
            }).then(() => {
                if (payingClientChanged) {
                    this.notifyViaTextChanged();
                }
                this.hasServicingClientAlerts(requestService);
            })
        }

        loadClientRequests(client: Model.ClientListItem)
        {
            if (client) {
                if (this.clientRequests) {
                    return this.$q.resolve(this.clientRequests);
                } else {
                    return this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.appointmentRequest, {
                        pageNumber: 0,
                        itemsPerPage: 10000,
                        criteria: { clientIds: [client.id] }
                    }).then((response: any[])=>
                    {
                        response.forEach(request =>
                            request.isExpired = _(request.dateTimeBands).all(band => moment(band.endDate) < moment().subtract(1, "days").endOf("day")));
                        this.clientRequests = response;
                    });
                }
            } else {
                this.clientRequests = [];
                return this.$q.resolve();
            }
        }
        
        private showClientChangedPrompt(editOption, appointmentRequest, client) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/waitList/waitListClientChangedPromptTemplate.html",
                controller: "meevo.plugins.waitList.WaitListClientChangedPromptController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    editOption: editOption,
                    appointmentRequest: appointmentRequest,
                    client: client
                }
            }

            return this.modalService.showCustom(options).then((result) => {
                if (result.option == WaitListClientChangedPromptEditOptionEnum.EditExpired) {
                    if (result.response == WaitListClientChangedPromptResponseEnum.Edit) {
                        this.getRequest(result.id).then((data) => {
                            data.id = undefined;
                            for (let band of data.dateTimeBands) {
                                band.endDate = undefined;
                            }
                            this.request = data;

                            this.setHasServicingClientAlerts();
                        });
                        this.dataService.trackUsage(Model.NounEnum.WaitListPage, Model.VerbEnum.Updated, null, result.id);
                    } 
                } else if (result.option == WaitListClientChangedPromptEditOptionEnum.EditActive) {
                    if (result.response == WaitListClientChangedPromptResponseEnum.Edit) {
                        this.getRequest(result.id).then((data) => {
                            this.request = data;
                            this.setHasServicingClientAlerts();
                        });
                        this.dataService.trackUsage(Model.NounEnum.WaitListPage, Model.VerbEnum.Updated, null, result.id);
                    } 
                }
            });
        }


        selectDaysOfWeek(dateTimeBand: Model.AppointmentRequestDateTimeBand, startDay, noOfDays) {
            if (noOfDays > 6)
                return [0, 1, 2, 3, 4, 5, 6];
            else {
                var daysOfWeek = [];
                var dayOfWeek = startDay;
                var i = 0;
                while (startDay <= dayOfWeek + noOfDays) {
                    daysOfWeek.push(moment(moment(dateTimeBand.startDate)).add(i, "days").day());
                    startDay++;
                    i++;
                }
                return daysOfWeek;
            }
        }

        employeeGenderSearchExclusionList = [Meevo.Model.EmployeeGenderSearchEnum.RandomEmployee];
        employeeGenderSearchFilterExclusionList = [Meevo.Model.EmployeeGenderSearchEnum.RandomEmployee, Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee];
        genderPreferenceChanged(requestService: any, index: number, isFilter = false) {
            // Hack: at runtime, genderPreference coming in as  a string not finding object in list.  Have to manually convert to int.
            let genderPreference: any = isFilter ? requestService.employeeGenderPreference : requestService.genderPreference;
            genderPreference = parseInt(genderPreference);
            let selectedGenderPreference: any = _.findWhere(this.employeeGenderSearchEnums, { id: genderPreference });
            if (selectedGenderPreference) {
                if (isFilter) {
                    requestService.employeeId = undefined;
                    requestService.employee = {
                        id: undefined,
                        displayName: selectedGenderPreference.displayName
                    }
                }
                else {
                    requestService.employeeId = undefined;
                    requestService.employees = [];
                    requestService.priceLevel = "";
                    requestService.employeeCat = undefined;
                    requestService.employeeCatId = undefined;
                    this.setEmployeeCriteria(requestService);
                
                    // need to rebuild so at the very least intellibooking enabled reset
                    this.rebuildSteps([requestService],index);
                }
            }
        }

        filterEmployeeChanged() {
            this.filterCriteria.employeeId = this.filterCriteria.employee ? this.filterCriteria.employee.id : null;
            this.filterCriteria.employeeGenderPreference = null;
        }

        getAllRequestServiceGenderPreferences(requestServices: Array<AppointmentRequestService>) {
            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.EmployeeGenderSearchEnum)
                .then((data: any) => {

                    for (let requestService of requestServices) {
                        if (!requestService.genderPreference) {
                            continue;
                        }

                        const selectedGenderPreference: any = _.findWhere(data, {id: requestService.genderPreference});
                        if (selectedGenderPreference && selectedGenderPreference.id !== Model.EmployeeGenderSearchEnum.SpecificEmployee) {
                            requestService.employee = {
                                id: undefined,
                                displayName: selectedGenderPreference.displayName
                            }
                        }
                    }
                });
        }

        updateRequestPriority = (clientId: string, priority: Number, item: any): void => {
            this.dataService.patch(this.appSettings.API_ENDPOINTS.appointmentRequest + "/" + clientId, { Model: { Priority: priority } })
                .then((response: any) => {
                    this.search();
                });
            this.dataService.trackUsage(Model.NounEnum.WaitListPage, Model.VerbEnum.PriorityChange, null, item.id).catch((reason) => { return; });
        }

        scanForOpenings = (appointmentRequest: any): void => {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WaitList, Model.VerbEnum.ScanButtonClicked, null, appointmentRequest.id));
            this.scanData.filter = appointmentRequest;
            this.busyService.start();
            this.scan(appointmentRequest.id).then((results) => {
                this.scanData.results = results.data;
                //let currentDate = results.data[0].serviceOpenings[0].date.toISOString();
                //this.scanData.selectedDate = currentDate;
                //this.scanData.openingMatrix = {};
                //this.scanData.openingMatrix[currentDate] = [];
                //for (var d = 0; d < results.data.length; d++) {
                //    var opening = results.data[d];
                //    if (opening.serviceOpenings[0].date.toISOString() == currentDate) {
                //        this.scanData.openingMatrix[currentDate].push(opening);
                //    } else {
                //        currentDate = opening.serviceOpenings[0].date.toISOString();
                //        this.scanData.openingMatrix[currentDate] = [opening];
                //    }
                //}
                this.busyService.stop();
            });
            this.showScan = true;
        }
        bookAppointment = (opening: any, firstOpening: any = null): void => {
            this.trackingService.saveTrackingInfo(new Meevo.Model.TrackingItem(Model.NounEnum.WaitListPage, Model.VerbEnum.ScanButtonClicked, null, this.scanData.filter.id));
            var services = [];
            this.getRequest(this.scanData.filter.id, false).then(request => {
                var payingClient = {
                    displayName: request.clientLastName + ", " + request.clientFirstName,
                    firstName: request.clientFirstName,
                    lastName: request.clientLastName,
                    id: request.payingClient.id,
                    primaryPhoneNumber: request.clientPhoneNumber
                }

                $.each(opening.serviceOpenings, function (index, serviceOpening) {
                    var service = {
                        client: payingClient,
                        employee: { displayName: serviceOpening.employeeName, id: serviceOpening.employeeId },
                        serviceId: serviceOpening.serviceId,
                        id: serviceOpening.serviceId,
                        service: { id: serviceOpening.serviceId },
                        transitionState: Meevo.Model.AppointStateEnum.Booked,
                        finalState: Meevo.Model.AppointFinalStateEnum.None,
                        resource: undefined,
                        resourceId: serviceOpening.resourceId,
                        resourceUnitId: serviceOpening.resourceUnitId,
                        genderPreference: serviceOpening.genderPreference,
                        nonRequest: serviceOpening.nonRequest,
                        startDateTime: serviceOpening.date,
                        startTime: moment(serviceOpening.startTime).format(),
                        price: serviceOpening.price,
                        steps: (serviceOpening.customServiceStepTimings || []).map(step => {
                            return {
                                serviceStepId: step.serviceStepId,
                                durationInMinutes: step.minutes
                            }
                        }),
                        serviceAddOns: []
                    }

                    services.push(service);
                });

                for (let i = 0; i < request.services.length; i++) {
                    let requestService = request.services[i];
                    if (requestService.serviceAddOns.length > 0) {
                        let appointmentService = services[i];
                        requestService.serviceAddOns.forEach(addOn => {
                            appointmentService.serviceAddOns.push({
                                addOnServiceId: addOn.addOnServiceId,
                                extendedByStepId: addOn.extendedByStepId,
                                extendedByStepMinutes: addOn.extendedByStepMinutes
                            })
                        })
                    }
                }
                var data = {};
                if (opening.serviceOpenings[0].isPending) {
                    data = {
                        appointmentId: opening.serviceOpenings[0].appointmentId,
                        startTime: opening.serviceOpenings[0].startTime,
                        date: opening.serviceOpenings[0].date,
                        services: services,
                        service: { id: opening.serviceOpenings[0].serviceId },
                        appointmentDate: opening.serviceOpenings[0].date,
                        isFromWaitList: true,
                        appointmentRequestId: this.scanData.filter.id
                    };
                    this.$rootScope.$broadcast("bookPendingAppointment", data);
                } else {

                    data = {
                        appointmentId: (firstOpening && firstOpening.serviceOpenings[0].isPending) ? firstOpening.serviceOpenings[0].appointmentId : null,
                        id: (firstOpening && firstOpening.serviceOpenings[0].isPending) ? firstOpening.serviceOpenings[0].id : null,
                        startTime: opening.serviceOpenings[0].startTime,
                        date: opening.serviceOpenings[0].date,
                        employee: services[0].employee,
                        payingClient: payingClient,
                        services: services,
                        service: { id: opening.serviceOpenings[0].serviceId },
                        appointmentDate: opening.serviceOpenings[0].date,
                        isFromWaitList: true,
                        note: opening.note,
                        optInClientSelectionAfterActions: false,
                        appointmentCategory: {id: request.appointmentCategoryId, appointmentCategoryDisplayName: request.appointmentCategoryDisplayName }
                    };
                    this.$rootScope.$broadcast("newAppointment", data);
                }
            });            
        }

        bookAppointmentSuccess = (event, data): void => {
            this.showScan = false;
            if (data.relatedAppointmentRequests)
                this.removeAppointment(data.relatedAppointmentRequests);
        }
        removeAppointment = (relatedAppointmentRequests): void => {
            this.deleteAppointmentRequest(0, relatedAppointmentRequests);
        }
        deleteAppointmentRequest = (relatedAppointmentRequestIndex, relatedAppointmentRequests): void => {
            if (relatedAppointmentRequestIndex == relatedAppointmentRequests.length) {
                this.search();
                return;
            }
            this.restServer.patchAppointmentRequest(relatedAppointmentRequests[relatedAppointmentRequestIndex].id, true, false, () => {
                this.deleteAppointmentRequest(++relatedAppointmentRequestIndex, relatedAppointmentRequests);
            });
        }

        showSteps(waitService)
        {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/AppointmentBookSteps.html",
                controller: "meevo.plugins.waitList.StepsModalController",
                bindToController: true,
                locals: {
                    waitService: waitService,
                    client: waitService.client
                }
            }
            this.modalService.showCustom(options);
        }
        
        applyParamsToContext(params: Model.AppointmentRequest) {

            if (Model.Guard.isSomething(params)
                && Model.Guard.isSomething(params.payingClientId)
                && Model.Guard.isSomething(params.services)
                && params.services.length > 0) {
                for (let service of params.services) {
                    if (service.employee) {
                        service.employees = [service.employee];
                        service.employee = undefined;
                    }
                }
                this.getAllRequestServiceGenderPreferences(params.services);
                this.request = params;
                this.payingClientChanged();
                if ((this.request.dateTimeBands || []).length === 0) {
                    this.addDateTimeBand();
                }
                for (let dateTimeBand of this.request.dateTimeBands) {
                    dateTimeBand.startTimeTemp = { value: this.request.dateTimeBands[0].startTime };
                    dateTimeBand.endTimeTemp = { value: this.request.dateTimeBands[0].endTime };
                    dateTimeBand.selectedPreset = this.getPreset(PresetStatus.Custom);
                }
              
                this.toggleEditor(this.request.dateTimeBands[0],
                    !params.dateTimeBands[0].daysOfWeek || params.dateTimeBands[0].daysOfWeek.length < 1);
                this.contextParams.params = {};
                
                this.isSidebarOpen = true;
                $("#dateChangeNote").html("");
            }
        }

        getDate(fullDate?: Date) {
            fullDate = fullDate || new Date();
            return new Date(fullDate.getFullYear(), fullDate.getMonth(), fullDate.getDate());
        }

        getPreset(selectedPreset: PresetStatus): any {
            return this.presetList.find(preset => preset.status === selectedPreset);
        }

        gotoClient(item) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    id: item.clientId,
                    initialEditSection: "SECTION_CLIENT_MAIN",
                    clientDisplayName: item.clientDisplayName
                }
            });
        }

        // Store these locally so not making extraneous api calls if just toggling checkbox
        clientId: string;
        actualNotifyClient: Model.Client;
        notifyViaTextChanged() {
            if (this.request.notifyViaText && this.request.payingClient) {
                let clientPromise = (this.clientId === this.request.payingClient.id) ? this.$q.resolve(this.actualNotifyClient) :
                    this.dataService.getItem("client", new Guid(this.request.payingClient.id)).then((client: Model.Client) => {
                        this.clientId = client.id;
                        if (client.isMinor && client.guardianId) {
                            return this.dataService.getItem("client", client.guardianId).then((client: Model.Client) => {
                                return client;
                            });
                        }
                        else {
                            return client;
                        }
                    })
                clientPromise.then((client: Model.Client) => {
                    this.actualNotifyClient = client;
                    if (!_(client.phoneNumbers).find((phone: Model.Phone) => {
                        return phone.type === Model.PhoneTypeEnum.Mobile &&
                            phone.number && phone.number != "" && phone.smsOptInStateEnum === Model.CommunicationOptedInStateEnum.OptedIn;
                    })) {
                        this.modalService.confirmHandler("MESSAGE_WAITLIST_CLIENT_NOT_OPTED_IN").then(response => {
                            if (response) {
                                var stateParams = {
                                    callback: () => { },
                                    callbackController: false,
                                    callbackState: this.$state.current.name,
                                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                                    actionState: Model.MaintenanceFormState.Editing,
                                    id: client.id,
                                    initialEditSection: "SECTION_CLIENT_MAIN",
                                    typeaheadMode: Meevo.Model.TypeaheadMode.Edit
                                };

                                this.$rootScope.$broadcast("gotoState", {
                                    stateName: "client",
                                    stateParams: stateParams
                                });
                            }
                        });
                    }
                });
            }
        }
    
        showServiceAddOns(waitService: Meevo.Model.AppointmentRequestService, index:number, isAutomated: boolean = false) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/serviceAddOns.html",
                controller: "meevo.plugins.appointmentBook.ServiceAddOnsController",
                bindToController: true,
                locals: {
                    serviceId: waitService.service.id,
                    employeeId: this.getEmployeeIdForAppointmentRequestService(waitService),
                    currentServiceAddOns: waitService.serviceAddOns,
                    finalState: Model.AppointFinalStateEnum.None,
                    transitionState: Model.AppointStateEnum.Booked,
                    isReadOnly: false,
                    isFromWalkIn: false,
                    clientId: waitService.client ? waitService.client.id : null,
                    serviceDisplayName: waitService.service.displayName,
                    isAutomated: isAutomated,
                    equipmentValidator: null,
                    yieldManagementDateTime: undefined,
                    applyProductUsage: false,
                    appointmentServiceId: undefined
                },
                controllerAs: "vm"
            };

            this.modalService.showCustom(options, Components.Modal.ModalTranslationModes.DoNotTranslate, true).then(response => {
                switch (response.action) {
                    case 'save':
                        const addOns = response.data;
                        addOns.forEach(addOn => {
                            addOn.sequenceId = waitService.id;
                        });
                        waitService.serviceAddOns = addOns;
                        break;
                    case 'close':
                    case 'cancel':
                        const hasRequired = response.data;
                        if (isAutomated && hasRequired) {
                            waitService.service = undefined;
                            this.serviceChanged(waitService,index);
                        }
                        break;
                }
                this.stepOverrideService.calculateStepDuration(waitService);
            })
        }
        commonRowChanged(appoitmentRequestService: Model.AppointmentRequestService, index: number) {
            if ((this.request.services.length - 1) == index && !device.mobile()) {
                if (appoitmentRequestService && appoitmentRequestService.client && appoitmentRequestService.service) {
                    let newAppointmentRequestService = _.clone(appoitmentRequestService);
                    newAppointmentRequestService.service = null;
                    newAppointmentRequestService.serviceId = null;
                    newAppointmentRequestService.priceLevel = "";
                    newAppointmentRequestService.employees = [];
                    newAppointmentRequestService.employeeCat = null;
                    newAppointmentRequestService.employeeCatId = null;
                    newAppointmentRequestService.genderPreference = Meevo.Model.EmployeeGenderSearchEnum.AnyEmployee;
                    this.setEmployeeCriteria(newAppointmentRequestService);
                    // This should ensure the DOM updates prior to attempting to set focus on the new line's service typeahead.
                    this.$timeout(() => {
                        this.request.services.push(newAppointmentRequestService);
                        this.$scope.$apply();
                    })
                        .then(function () {
                            var control = angular.element('meevo-type-ahead#opensesame-service-' + (index + 1));
                            control.find('input').focus();
                            return true;
                        });
                }
            }
        }

        showServiceDescription = (service: any) => {
            if (service) {
                let options = {
                    templateUrl: "app/plugins/AppointmentBook/views/serviceInformation.html",
                    controller: "meevo.plugins.appointmentBook.ServiceInformationController",
                    controllerAs: "vm",
                    bindToController: true,
                    skipHide: true,
                    locals: { serviceId: service.id }
                }
                this.modalService.showCustom(options);
            }
        }

        sendToTransactionHistory(client) {
            this.$appointmentBookModal.sendToTransactionHistory(client, "SECTION_HISTORY",
                this.enableIntegratedRegister ? "TRANSACTION_HISTORY" : "APPOINTMENT_HISTORY");
        }

        isLastRow(index: number) {
            return (this.items.numItems - 1) == index;
        }

        appointmentCategoryChanged():void {
            if (!this.request) {
                return;
            }

            if (!this.requestAppointmentCategory) {
                this.request.appointmentCategoryId = this.request.appointmentCategoryDisplayName = null;
                return;
            }

            this.request.appointmentCategoryId = this.requestAppointmentCategory.id;
            this.request.appointmentCategoryDisplayName = this.requestAppointmentCategory.appointmentCategoryDisplayName;
        }

        showAudit(item) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/AppointmentAuditLog.html",
                controller: "AppointmentAuditLogController",
                bindToController: true,
                locals: {
                    appointmentRequestId: item.id,
                    appointmentServiceScheduleId: undefined,
                    appointmentId: undefined
                }
            }
            this.modalService.showCustom(options);
        }
        
        private hidePayingClientAlerts() {
            this.showPayingClientAlerts = false;
        }

        public hasPayingClientAlerts() {
            this.showPayingClientAlerts = true;
        }

        employeeDisplay(service) {
            if (service.employees && service.employees.length > 0) {
                return _(service.employees).pluck("code").join(", ");
            }
            return service.employeeGenderSearchDisplayName;
        }

        public hideServicingClientAlerts(requestService: any) {
            requestService.showClientAlerts = false;
        }

        public hasServicingClientAlerts(requestService: any) {
            requestService.showClientAlerts = !!requestService.client;
        }

        private setHasServicingClientAlerts() {
            for (let requestService of this.request.services) {
                if (!requestService.client || !requestService.client.id) {
                    continue;
                }
                this.hasServicingClientAlerts(requestService);
            }
        }
    }

    angular.module("meevo.plugins.waitList")
        .controller("meevo.plugins.waitList.WaitListController", WaitListController);
}
